export enum WMY {
  WEEK = 'WEEK',

  MONTH = 'MONTH',

  YEAR = 'YEAR',
}
